import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function CompanyFormationGibraltar() {

    return (
        <main className='main'>
            <SEO
                title="Gibraltar Company Formation | EU Offshore Setup "
                description="Incorporate a Gibraltar company with 0% offshore tax, strong regulation, and access to UK and EU markets via a trusted jurisdiction. "
                keywords="Gibraltar company formation, Gibraltar incorporation, offshore company Gibraltar, Gibraltar tax benefits, EU connected company Gibraltar, UK market access Gibraltar, fintech Gibraltar company, offshore jurisdiction Gibraltar "
                url="/company-formation-gibraltar"
            />
            <IntroSection
                title="Company Formation in Gibraltar"
                subtitle="Establish Your EU-Connected Offshore Business in Gibraltar"
                description="Gibraltar is a strategic business hub at the gateway of Europe, offering 0% tax on offshore income, a strong regulatory framework, and access to the UK market post-Brexit. With its English legal system, stable economy, and reputation as a trusted offshore jurisdiction, Gibraltar is a preferred choice for entrepreneurs, fintech firms, and licensed operators."
                badges={[
                    "0% Tax on Offshore Profits",
                    "Strong Legal Framework",
                    "EU & UK Market Access"
                ]}
                buttonText="Request a Gibraltar Company Formation Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/company-formation/mwali-hero-image.png')}
                imageAlt="Gibraltar Company Formation"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Incorporate in Gibraltar?"
                        blocks={[
                            {
                                items: [
                                    { text: "0% Tax on offshore-sourced income." },
                                    { text: "English Common Law framework ensures legal stability." },
                                    { text: "EU & UK Connectivity – recognized gateway for trade and finance." },
                                    { text: "Fast Incorporation – typically within 5–7 business days." },
                                    { text: "Reputation – respected for financial services, gaming, and fintech." },
                                    { text: "Local Substance Options – available for EU-facing companies." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Types of Companies in Gibraltar"
                        blocks={[
                            {
                                items: [
                                    { title: "Private Limited Company (Ltd)", text: "Most common for SMEs and holding structures." },
                                    { title: "Public Limited Company (PLC)", text: "Suitable for larger enterprises and regulated businesses." },
                                    { title: "Non-Resident Company", text: "No Gibraltar-source income, 0% tax on foreign profits." },
                                    { title: "Limited Liability Partnerships (LLP)", text: "For professional services and joint ventures." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Key Features"
                        blocks={[
                            {
                                items: [
                                    { text: "Minimum Share Capital: £100 (no maximum)." },
                                    { text: "Directors: Minimum 1 (individual or corporate, can be foreign)." },
                                    { text: "Shareholders: Minimum 1 (individual or corporate, can be foreign)." },
                                    { text: "Secretary: Required." },
                                    { text: "Accounting & Audits: Annual filings required." },
                                    { text: "Taxation: 12.5% on local income; 0% on non-Gibraltar sourced." },
                                    { text: "Substance: Required if company manages activities targeting EU markets." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Incorporation Process"
                        blocks={[
                            {
                                items: [
                                    { text: "Name Reservation with Companies House Gibraltar." },
                                    { text: "Submission of Memorandum & Articles of Association." },
                                    { text: "Appointment of Directors/Shareholders." },
                                    { text: "Issuance of Certificate of Incorporation." },
                                    { text: "Opening of Bank Account." },
                                    { text: "Timeline: ~5–7 business days." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Popular Uses of Gibraltar Companies"
                        blocks={[
                            {
                                items: [
                                    { text: "Gaming & iGaming Operations (Gibraltar is Tier-1 in online gambling)." },
                                    { text: "FinTech & Payments (PSP, EMI, DLT companies)." },
                                    { text: "Banking & Financial Services." },
                                    { text: "Holding & Investment Vehicles." },
                                    { text: "Asset Protection & Wealth Management." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Why Offshore Advisory for Gibraltar?"
                        blocks={[
                            {
                                items: [
                                    { text: "Direct liaison with Companies House Gibraltar." },
                                    { text: "Expertise in gaming, fintech, and regulated entities." },
                                    { text: "Bank account assistance in Gibraltar & EU." },
                                    { text: "Optional nominee services for privacy." },
                                    { text: "End-to-end compliance, accounting & audit support." }
                                ]
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to establish your Gibraltar company?"
                        description="Offshore Advisory provides fast incorporation, licensing, and banking solutions in Gibraltar."
                        buttonText="Book a Free Consultation for Gibraltar Company Formation"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How long does it take to incorporate a company in Gibraltar?",
        answer: "Typically 5–7 business days.",
    },
    {
        question: "Do I need to be in Gibraltar to incorporate?",
        answer: "No, incorporation can be done remotely via Offshore Advisory.",
    },
    {
        question: "Is Gibraltar tax-free?",
        answer: "Yes, offshore income is tax-free. Only local-source income is taxed at 12.5%.",
    },
    {
        question: "Can Gibraltar companies open EU bank accounts?",
        answer: "Yes, many Gibraltar entities successfully open accounts in Gibraltar, the UK, and EU financial centers.",
    },
    {
        question: "Is Gibraltar suitable for crypto or gaming businesses?",
        answer: "Yes, Gibraltar is a Tier-1 jurisdiction for both gaming and blockchain/DLT licensing.",
    },
];
